var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1531",
    "data-name": "Rectangle 1531",
    width: 24,
    height: 24,
    transform: "translate(16292 1488)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_monitor",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    transform: "translate(16292 1489.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices-svgrepo-com_3_",
    "data-name": "devices-svgrepo-com (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_175",
    "data-name": "Union 175",
    d: "M17.5,21.317H6.5a1.115,1.115,0,0,1-.121.007,1.062,1.062,0,0,1-1.052-.895,1.062,1.062,0,0,1,1.051-.9,1.012,1.012,0,0,1,.122.007H8.882V17.764H1.777A1.778,1.778,0,0,1,0,15.987V1.777A1.778,1.778,0,0,1,1.777,0H22.223A1.778,1.778,0,0,1,24,1.777V15.987a1.779,1.779,0,0,1-1.777,1.777H15.117v1.777H17.5a1.014,1.014,0,0,1,.122-.007,1.061,1.061,0,0,1,1.051.9,1.062,1.062,0,0,1-1.052.895A1.112,1.112,0,0,1,17.5,21.317Zm4.725-5.33V1.777H1.777V15.987H22.223Z",
    fill: "#003fb9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eye-svgrepo-com",
    transform: "translate(7.2 5.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M9.361,118.917a.3.3,0,0,0,0-.289,5.3,5.3,0,0,0-9.324,0,.3.3,0,0,0,0,.289,5.3,5.3,0,0,0,9.324,0ZM4.7,121.012a2.24,2.24,0,1,1,2.24-2.24A2.24,2.24,0,0,1,4.7,121.012Z",
    transform: "translate(0 -115.853)",
    fill: "#003fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M232.81,231.67a1.144,1.144,0,0,0-.273.033.592.592,0,0,1-.835.835,1.141,1.141,0,1,0,1.108-.868Z",
    transform: "translate(-228.112 -229.892)",
    fill: "#003fb9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonitor);
export default __webpack_public_path__ + "static/media/ic_monitor.9f4428da9b6320ff69abc434d8073158.svg";
export { ForwardRef as ReactComponent };